import './App.css';
import TodoContainer from "./TodoContainer";

function App() {
  return (
    <div className="App">
      <TodoContainer/>
    </div>
  );
}

export default App;
